import { InternalURL } from "./internal-url";

export function createProfileLinkRequestsPageURL() {
  const path = `/account/moderator/tasks/creator_links`;

  return new InternalURL(path);
}
